import { useTranslation } from 'react-i18next';
import useTranslate from '../../../../../hooks/useTranslate';
import useTableMenu from '../../../../../hooks/useTableMenu';
import useGlobalFilters from '../../../../../hooks/useGlobalFilters';
import { useGetSubstancesQuery } from '../../../../../services/carcinogenicApi';
import { useAppSelector } from '../../../../../hooks/reduxHooks';
import { useState } from 'react';
import { CARCINOGENIG_SUBSTANCES_DRAWER_ACTION_VALUES } from '../components/drawers';

const useSubstancesModule = () => {
    const [selectedItemFromAction, setSelectedItemFromAction] = useState<any>(null);
    const [selected, setSelected] = useState<any | null>(null);
    const [open, setOpen] = useState<string>('');

    const selectedEstablishmentId = useAppSelector(
        (state) => state.establishment.selectedEstablishmentId
    );

    const substancesTableMenu = useTableMenu();
    const substancesFilters = useGlobalFilters();
    const { filters } = substancesFilters;
    const { handleOpenCard, anchorToEventElement, openMenu, menuOpen } = substancesTableMenu;

    const { data: substances, isFetching: isFetchingSubstances } = useGetSubstancesQuery(
        { idEstablecimiento: selectedEstablishmentId || 0, ...filters },
        { skip: !selectedEstablishmentId }
    );

    const { t } = useTranslation('carcinogenicReport', {keyPrefix: 'modules.substancesAndPreventiveMeasures'});
    const { translate } = useTranslate(t);

    const handleRowClick = (selectedRowItem: any) => {
        setSelectedItemFromAction(selectedRowItem);
        setSelected(selectedRowItem);
        handleOpenCard();
    };

    const handleClickAction = (event: any, item: any, index: any) => {
        setSelectedItemFromAction(item);
        anchorToEventElement(event);
        openMenu();
    };

    const handleEditClick = (selectedSubstance: any) => {
        setSelected(selectedSubstance)
        setOpen(CARCINOGENIG_SUBSTANCES_DRAWER_ACTION_VALUES.SUBSTANCE_INFORMATION);
    };

    return {
        substances,
        isFetchingSubstances,
        substancesTableMenu,
        substancesFilters,
        selectedItemFromAction,
        selected,
        open,
        menuOpen,
        setOpen,
        translate,
        handleRowClick,
        handleEditClick,
        handleClickAction
    };
};

export default useSubstancesModule;
